// List of country codes allowed for PO creation (should match backend config)
const whitelistedCountries = [
	"IN", // India
	"CN", // China
	"IE", // Ireland
	"FR", // France
	"DE", // Germany
	"IT", // Italy
	"ES", // Spain
	"NL", // Netherlands
	"RS", // Serbia
];

export default whitelistedCountries;
